export interface ICompanyData {
  create: {
    config: {
      isLoading: boolean;
    };
  };
}

const companyInitialState: ICompanyData = {
  create: {
    config: {
      isLoading: false,
    },
  },
};

export default companyInitialState;
